import { faGripDotsVertical, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    classnames, SimpleCard,
    Sortable
} from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import { RoomDto } from '@/types';
import theme from './ProjectRooms.module.scss';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';

interface SortableItemProps {
    room: RoomDto;
    active: boolean;
    onTagClick(room: RoomDto): void;
    handleProps: object;
    isDragging: boolean;
}

const SortableItem: React.FC<SortableItemProps> = ({ room, active, onTagClick, handleProps, isDragging }) => {
    return (
        <SimpleCard className={classnames({ [theme.active]: active, [theme.isDragging]: isDragging }, theme.row)}>
            <div onClick={() => onTagClick(room)} className={theme.rowContent}>
                <div className={theme.dragHandle} {...handleProps}>
                    <FontAwesomeIcon icon={faGripDotsVertical} size="lg" />
                </div>
                {room.icon && <FontAwesomeIcon icon={['fal', room.icon]} />}

                <div className={theme.roomLabels}>
                    <div>{room.name || <Trans>New room</Trans>}</div>
                    {room.labelNote && <div className={theme.note}>{room.labelNote}</div>}
                </div>
            </div>
        </SimpleCard>
    );
};

export interface RoomListProps {
    tags: RoomDto[];
    activeTagId: number | null;
    isNewRoomActive?: boolean;
    onTagClick(tag: RoomDto): void;
    onDelete(room: RoomDto): void;
    onNewClick?(): void;
    onSortEnd(event: { oldIndex: number; newIndex: number }): void;
    listEndRef?: React.RefObject<HTMLDivElement>;
}
export const RoomList: React.FC<RoomListProps> = ({ tags, activeTagId, isNewRoomActive, onTagClick, onNewClick, onSortEnd, onDelete, listEndRef }) => {
    const handleNewClick = () => {
        onNewClick?.();
    };

    return (
        <div className={theme.sectionsList}>
            {onNewClick && (
                <Button variant="primary" className={theme.addButton} icon={faPlus} onClick={handleNewClick}>
                    <Trans>New room</Trans>
                </Button>
            )}
            <Sortable items={tags} idField="id" onSortEnd={onSortEnd} direction="vertical">
                {(tag, { handleProps, isDragging }) => (
                    <SortableItem
                        handleProps={handleProps}
                        active={tag.id ? activeTagId === tag.id : !!isNewRoomActive}
                        onTagClick={onTagClick}
                        room={tag}
                        isDragging={isDragging}
                    />
                )}
            </Sortable>
            <div ref={listEndRef} />
        </div>
    );
};
